var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 194.145,
    height: 101.442,
    viewBox: "0 0 194.145 101.442",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undulating-arrow",
    transform: "translate(11.711 -1.144) rotate(14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M159.5,26.289C140.1,3.967,109.811,12.47,85.63,20.442,71.546,24.959,57.2,30.275,42.05,30.54,22.917,30.806,11.225,16.456,3.253.778,2.456-.817-.467.246.064,2.107,11.225,31.6,33.812,40.638,63.308,33.463c30.559-7.441,64.572-28.433,92.209-3.455A2.726,2.726,0,1,0,159.5,26.289Z",
    transform: "translate(0 12.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M161.949,24.546c-20.2-24.713-49.691-19.4-77.062-10.629C70.272,18.7,55.657,24.546,39.978,25.609,22.174,26.938,10.748,16.308,3.573.9,2.776-.964-.679.364.119,2.225c27.1,74.14,115.062-25.51,157.313,26.308C160.355,31.721,164.341,27.469,161.949,24.546Z",
    transform: "translate(4.729)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M131.231,58.648a3,3,0,0,1-.11-6L182,50.756,176.114,6.62a3,3,0,0,1,5.947-.793l6.761,50.68-57.477,2.14Z",
    transform: "translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.dc233fb77565fe00dff76b45a3e9f1a1.svg";
export { ForwardRef as ReactComponent };